let BASE_URL = `https://approval-user-service.herokuapp.com`;

let SERVER = `/api`;

module.exports = {
  endpoint: `${BASE_URL}`,
  BASE_URL,
  SERVER,
};
